import * as React from "react";
import { Form, Row, Col, Select } from "antd";

interface DataCurrencyFormProps {
  currency: string;
  onCurrencyChange: (value: string) => void;
}

const DataCurrencyForm: React.FC<DataCurrencyFormProps> = ({
  currency,
  onCurrencyChange,
}) => {

  return (
    <div>
      <Form.Item name="currency" className="!mb-2">
        <Row align="middle" gutter={16}>
          {/* Data Source */}
          <Col span={12}>
            <Row align="middle">
              <Col span={8} style={{ display: "flex", justifyContent: "flex-start" }}>
                <label htmlFor="currency-value" className="">
                  Data Currency:
                </label>
              </Col>
              <Col span={16} style={{ display: "flex", justifyContent: "flex-start" }}>
                <span>{currency}</span>
              </Col>
            </Row>
          </Col>

          {/* As of Date */}
          <Col span={12}>
            <Form.Item name="currency" className="!mb-0">
              <Row align="middle">
                <Col span={8} style={{ display: "flex", justifyContent: "flex-start" }}>
                  <label htmlFor="output-currency" className="">
                    Data Output Currency:
                  </label>
                </Col>
                <Col span={16} style={{ display: "flex", justifyContent: "flex-start" }}>
                  <Select<string>
                    id="output-currency"
                    value={currency}
                    onChange={(value) => {
                      onCurrencyChange(value);
                    }}
                    style={{ width: "70%" }}
                    options={[
                      { label: "USD", value: "USD" },
                      { label: "GBP", value: "GBP" },
                      { label: "EUR", value: "EUR" },
                      { label: "JPY", value: "JPY" },
                      { label: "AUD", value: "AUD" },
                      { label: "CNY", value: "CNY" },
                    ]}
                    />
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
    </div>
  );
};

export default DataCurrencyForm;
